<template>
  <el-row class="container" :gutter="20">
    <!-- Columna Filtros -->
    <el-col class="container_col_1" :span="6">
      <el-row style="margin-bottom: 15px; margin-top: 1rem">
        <el-col :span="16">
          <div class="title">{{ $t("NAVBAR_pendientes") }}</div>
        </el-col>
      </el-row>

      <!-- Busqueda simple -->
      <el-row>
        <el-collapse v-model="activeNames" style="margin-bottom: 6px">
          <el-collapse-item
            class="busqueda"
            :title="$t('GENERAL_Busqueda')"
            name="1"
          >
            <div class="filters">
              <div v-if="buscarClientes">
                <div class="filters_item">
                  <div class="label">{{ $t("RESUMENDECUENTA_clientes") }}</div>
                  <!--Selector autocomplete para elegir el cliente-->
                  <el-select
                    class="seleccionador"
                    v-model="clienteSeleccionado"
                    filterable
                    reserve-keyword
                    :placeholder="$t('RESUMENDECUENTA_clientes_placeholder')"
                    remote
                    :remote-method="remoteMethod"
                    @change="getCuentasClientesDelayed"
                    value-key="Id"
                  >
                    <el-option
                      v-for="item in clientesOption"
                      :key="item.Id"
                      :label="item.RazonSocial"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div
                  class="filters_item"
                  v-if="clienteSeleccionado != undefined && buscarClientes"
                >
                  <div class="label">{{ $t("RESUMENDECUENTA_cuentas") }}</div>
                  <!--Selector para elegir la cuenta del cliente seleccionado-->
                  <el-select
                    class="seleccionador"
                    :placeholder="$t('RESUMENDECUENTA_cuentas_placeholder')"
                    v-model="filtros.cuentaCorriente"
                    size="small"
                    :loading="loadingCuentas"
                    @change="getPendientes"
                    clearable
                    @clear="borrarFiltros"
                    value-key="Id"
                  >
                    <el-option
                      v-for="item in cuentasCorrientes"
                      :key="item.Id"
                      :label="item.Descripcion"
                      :value="item"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div v-else>
                <div class="filters_item">
                  <div class="label">
                    {{ $t("PENDIENTES_cuenta_corrientes") }}
                  </div>
                  <el-select
                    class="seleccionador"
                    size="small"
                    v-model="filtros.cuentaCorriente"
                    :placeholder="$t('PENDIENTES_cc_placeholer')"
                    @change="getPendientes"
                  >
                    <el-option
                      v-for="cuentaCorriente in cuentasCorrientes"
                      :key="cuentaCorriente.Id"
                      :value="cuentaCorriente.Id"
                      :label="cuentaCorriente.Descripcion"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="filters_item">
                <div class="label">{{ $t("PENDIENTES_estado_vencimiento") }}</div>
                <el-select
                  class="seleccionador"
                  size="small"
                  v-model="filtros.vencida"
                  @change="resetPagination"
                >
                  <el-option
                    :value="null"
                    :label="$t('PENDIENTES_todos')"
                  ></el-option>
                  <el-option
                    value="N"
                    :label="$t('PENDIENTES_a_vencer')"
                  ></el-option>
                  <el-option
                    value="S"
                    :label="$t('PENDIENTES_vencido')"
                  ></el-option>
                </el-select>
              </div>

              <div class="filters_item">
                <div class="label">{{ $t("PENDIENTES_agrupar_por") }}</div>
                <el-select
                  class="seleccionador"
                  size="small"
                  v-model="filtros.agrupamiento"
                  @change="resetPagination"
                >
                  <el-option
                    :value="1"
                    :label="$t('PENDIENTES_sin_agrupar')"
                  ></el-option>
                  <el-option
                    :value="2"
                    :label="$t('PENDIENTES_semana')"
                  ></el-option>
                  <el-option
                    :value="3"
                    :label="$t('PENDIENTES_mes')"
                  ></el-option>
                </el-select>
              </div>

              <div class="clearFilters" @click="cleanFilters">
                {{ $t("GENERAL_clean_filters") }}
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item
            class="busqueda"
            :title="$t('PENDIENTES_exportar')"
            name="2"
          >
            <el-button
              class="btnExportarExcel"
              type="primary"
              size="large"
              @click="exportExcel"
              round
              style="margin-top: 1rem"
              :disabled="!(datos && datos.length) || !showTable"
            >
              {{ $t("PENDIENTES_descargar_excel") }}
              <el-icon v-if="!estaDescargandoExcel"><Notebook /></el-icon>
              <el-icon v-else class="is-loading"><Loading /></el-icon>
            </el-button>
          </el-collapse-item>
        </el-collapse>
      </el-row>
    </el-col>

    <el-col class="container_col_2" :span="18" v-if="showTable">
      <el-row class="hidden-xs-only" type="flex" justify="space-between">
        <el-col :sm="12" :md="16">
          <div class="sub-title" v-if="buscarClientes && clienteSeleccionado && filtros.cuentaCorriente">
                {{clienteSeleccionado.RazonSocial}} -  {{clienteSeleccionado.Clave}}
              </div>
          <div class="sub-title">{{ cuentaCorriente }} {{ formaDePago }}</div>
          <div class="caption" v-show="datosUsuario.RazonSocial">
            {{
              $t("RESUMENDECUENTA_razonSocial") +
              ": " +
              datosUsuario.RazonSocial +
              " - " +
              $t("RESUMENDECUENTA_CodigoEmpresa") +
              ": " +
              datosUsuario.Clave
            }}
          </div>
        </el-col>
        <el-col :sm="12" :md="8" style="text-align: right">
          <el-button
            class="realizar-consulta-btn"
            style="margin-bottom: 5px"
            @click="realizarConsulta"
            >{{ $t("RESUMENDECUENTA_RealizarConsulta") }}</el-button
          >
          <el-pagination
            background
            small
            layout="prev, pager, next"
            :current-page="paginador.page"
            :page-count="paginador.nro_pages"
            :page-size="paginador.pageSize"
            @current-change="handlePageChange"
            hide-on-single-page
          >
          </el-pagination>
        </el-col>
      </el-row>
      <!-- row para la vista desde un celular  -->
      <div class="hidden-sm-and-up" style="margin-bottom: 20px">
        <div class="sub-title">{{ cuentaCorriente }} {{ formaDePago }}</div>
        <div class="caption" v-show="datosUsuario.RazonSocial">
          {{
            $t("RESUMENDECUENTA_razonSocial") +
            ": " +
            datosUsuario.RazonSocial +
            " - " +
            $t("RESUMENDECUENTA_CodigoEmpresa") +
            ": " +
            datosUsuario.Clave
          }}
        </div>
      </div>
      <!-- row para la vista desde un celular  -->
      <el-row
        class="hidden-sm-and-up"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <el-button class="realizar-consulta-btn" @click="realizarConsulta">{{
          $t("RESUMENDECUENTA_RealizarConsulta")
        }}</el-button>
        <el-pagination
          background
          small
          layout="prev, pager, next"
          :current-page="paginador.page"
          :page-count="paginador.nro_pages"
          :page-size="paginador.pageSize"
          @current-change="handlePageChange"
          hide-on-single-page
        >
        </el-pagination>
      </el-row>
      <el-row class="pendientes-table-row">
        <TablaPendientes
          class="pendientes-table"
          :cuentaCorriente="cuentaCorriente"
          :formaDePago="formaDePago"
          :tipoTabla="filtros.agrupamiento"
          :datos="datos"
          :totalDebe="totalDebe"
          :totalHaber="totalHaber"
          :loading="loading"
          :showTable="showTable"
          ref="TablaPendientes"
        />
      </el-row>

      <!-- row para la vista desde un celular  -->
      <el-row style="margin: 10px auto" type="flex" justify="end">
        <el-pagination
          background
          small
          layout="prev, pager, next"
          :current-page="paginador.page"
          :page-count="paginador.nro_pages"
          :page-size="paginador.pageSize"
          @current-change="handlePageChange"
          hide-on-single-page
        >
        </el-pagination>
      </el-row>
    </el-col>
    <el-col class="container_col_2" :span="18" v-else>
      <div class="sub-title" style="margin-top: 1rem; text-align: center">
        {{ $t("PENDIENTES_buscar") }}
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from "vuex";
import i18n from "../../plugins/i18n";
import TablaPendientes from "@/components/Pendientes/tablaPendientes";
import { showError } from "../Mensaje";
import { tienePermiso } from '../../security/autorizador';
import { targets } from "../../security/target";

let defaultPaginador = {
  page: 1,
  nro_pages: 1,
  pageSize: 10,
};

export default {
  name: "PendientesList",
  components: { TablaPendientes },
  props: {
    //buscarClientes: Boolean,
  },
  data() {
    return {
      buscarClientes: undefined,
      activeNames: ["1"],
      cuentasCorrientes: [],
      filtros: {
        cuentaCorriente: null,
        agrupamiento: 1,
        vencida: null,
      },
      paginador: { ...defaultPaginador },
      datos: [],
      loading: false,
      descargandoExcel: false,
      totalDebe: null,
      totalHaber: null,
      datosUsuario: {},
      //Clientes
      clientes: [],
      clienteSeleccionado: undefined,
      clientesOption: [],
      mod: this.buscarClientes? "clientes" : "cuentaCorriente"
    };
  },


  // created() {
  //   tienePermiso(targets.Menu_Clientes) ? this.buscarClientes = true : this.buscarClientes = false;


  //   if (this.buscarClientes) {
  //     /*Request para obtener listado de clientes*/
  //     this.getClientes();
  //   } else {
  //     //Recupero los filtros
  //     this.filtros = this.filtrosCuentaCorriente;
  //     //obtengo las cuentas corrientes
  //     this.getCuentasCorrientes();
  //   }
  // },

  
  mounted() {
    this.getDatosUsuario();

    tienePermiso(targets.Menu_Clientes) ? this.buscarClientes = true : this.buscarClientes = false;


    if (this.buscarClientes) {
      /*Request para obtener listado de clientes*/
      this.getClientes();
    } else {
      //Recupero los filtros
      this.filtros = this.filtrosCuentaCorriente;
      if (this.filtros.vencida === "null") this.filtros.vencida = null;
      if (this.filtros.vencida === undefined) this.filtros.vencida = null;
      //obtengo las cuentas corrientes
      this.getCuentasCorrientes();
    }
  },
  unmounted() {
    //Antes de abandonar la pagina guardamos los filtros
    this.$store.dispatch(
      "cuentaCorriente/setFiltrosCuentaCorriente",
      this.filtros
    );
  },
  methods: {
    realizarConsulta() {
      this.$router.push({
        name: "Contacto",
        params: {
          cuenta: this.cuentasCorrientes.find(
            (x) => x.Id == this.filtros.cuentaCorriente
          ).Descripcion,
        },
      });
    },
    getDatosUsuario() {
      this.$store
        .dispatch("sesion/getDatosUsuario", this.idUsuario)
        .then((data) => {
          this.datosUsuario = data;
        });
    },
    exportExcel() {
      this.descargandoExcel = true;
      let idioma = i18n.locale;
      let index = Math.floor(Math.random() * (9999 - 1) + 1);

      if (
        this.filtros.cuentaCorriente === 0 &&
        this.filtros.agrupamiento === 0
      ) {
        showError(this.$t("PENDIENTES_error_exportar1"));
        this.descargandoExcel = false;
        return;
      }

      let payload = {
        //idCuenta: this.filtros.cuentaCorriente.Id,
        idCuenta: this.buscarClientes ? this.filtros.cuentaCorriente.Id : this.filtros.cuentaCorriente,
        nombreCuenta: this.cuentaCorriente,
        agrupamiento: this.filtros.agrupamiento,
        formaDePago: this.formaDePago,
        razonSocial: this.datosUsuario.RazonSocial,
        clave: this.datosUsuario.Clave,
        page: this.paginador.page,
        idioma: idioma,
        paginar: false,
      };
  
      this.$store.dispatch("cuentaCorriente/exportarExcel", payload).then((response) => {
          let link = document.createElement("a");
          link.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" +
            ";base64," +
            encodeURIComponent(response.Datos);
          link.target = "_blank";
          console.log(link.href);
          link.setAttribute(
            "download",
            this.$t("NAVBAR_pendientes") + "_" + index + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => showError(error))
        .finally(() => (this.descargandoExcel = false));
    },
    borrarFiltros() {
      this.filtros.cuentaCorriente = null;
      this.filtros.agrupamiento = 1;
      this.filtros.vencida = null;
      this.paginador = { ...defaultPaginador };
    },
    cleanFilters() {
      this.clienteSeleccionado = undefined;
      this.filtros.cuentaCorriente = null;
      this.filtros.agrupamiento = 1;
      this.filtros.vencida = null;
      this.paginador = { ...defaultPaginador };
    },
    getPendientes() {
      if (this.filtros.cuentaCorriente && this.filtros.agrupamiento) {
        this.loading = true;
        //Armamos el payload y limpiamos los datos
        this.datos = [];

        const payload = {
          idCuenta: this.buscarClientes ? this.filtros.cuentaCorriente.Id : this.filtros.cuentaCorriente,
          agrupamiento: this.filtros.agrupamiento,
          vencida: this.filtros.vencida,
          page: this.paginador.page,
          pageSize: this.paginador.pageSize,
        };
        console.log(payload)
        this.$store
          .dispatch(this.mod + "/getCuentasPendientes", payload)
          .then((response) => {
            if (response && response.Datos && response.Datos.Pendientes) {
              this.datos = response.Datos.Pendientes.Result || [];
              this.paginador.nro_pages = response.Datos.Pendientes.TotalPages || 1;
              this.totalDebe = response.Datos.TotalDebe || 0;
              this.totalHaber = response.Datos.TotalHaber || 0;
            } else {
              this.datos = [];
              this.paginador.nro_pages = 1;
              this.totalDebe = 0;
              this.totalHaber = 0;
            }
          })
          .catch((error) => showError(error))
          .finally(() => (this.loading = false));
      }
    },
    getPendientesDelayed() {},
    getCuentasCorrientes() {
      //armo el payload y consulto las cuentas corrientes del usuario
      const payload = {
        idUSuario: this.idUsuario,
      };
      this.$store
        .dispatch(this.mod + "/getCuentasCorrientes", payload)
        .then((response) => {
          this.cuentasCorrientes = !response.Datos
            ? this.cuentasCorrientes
            : response.Datos;
          if (this.cuentasCorrientes && this.cuentasCorrientes.length)
            this.filtros.cuentaCorriente = this.filtrosCuentaCorriente
              .cuentaCorriente
              ? this.filtrosCuentaCorriente.cuentaCorriente
              : this.cuentasCorrientes[0].Id;
          if (!this.filtrosCuentaCorriente.agrupamiento)
            this.filtros.agrupamiento = 1;
          this.getPendientes();
        })
        .catch(() => {
          showError(this.$t("GETCUENTASCORRIENTES_error"));
        });
    },
    handlePageChange(page) {
      this.paginador.page = page;
      this.getPendientes();
    },
    resetPagination() {
      this.paginador = { ...defaultPaginador };
      this.getPendientes();
    },
    //Metodos Clientes
    getClientes() {
      return this.$store
        .dispatch("clientes/getClientes")
        .then((data) => {
          if (data.CodigoResultado == 0) {
            this.clientes = data.Datos;
          }
        })
        .catch(() => showError(this.$t("RESUMENDECUENTA_errorObtencionClientes")))
        .finally(() => (this.loading = false));
    },
    //Una vez seleccionado un cliente, debemos buscar sus cuentas corrientes
    getCuentasCliente() {
      return this.$store
        .dispatch("clientes/getCuentasCorrientes", this.clienteSeleccionado.Id)
        .then((data) => {
          if (data.CodigoResultado == 0) {
            this.cuentasCorrientes = data.Datos;
          }
        })
        .catch(() => showError(this.$t("RESUMENDECUENTA_errorObtencionCuentas")))
        .finally(() => (this.loading = false));
    },
    //Ante un cambio en la seleccion del cliente, debemos consultar las cuentas nuevamente
    getCuentasClientesDelayed(item) {
      if (this.buscarClientes) {
        // this.filtros.cuenta = undefined
        // this.totalDebe = undefined;
        // this.totalHaber = undefined;
        // this.documentos = undefined;
      }

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.clienteSeleccionado = item;
        this.paginador = { ...defaultPaginador };
        this.getCuentasCliente();
      }, 500);
    },
    remoteMethod(query) {
      if (query !== "" && query.length >= 3) {
        setTimeout(() => {
          this.clientesOption = this.clientes.filter((item) => {
            return (
              item.RazonSocial.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.clientesOption = [];
      }
    },
  },
  computed: {
    estaDescargandoExcel() {
      return this.descargandoExcel;
    },
    ...mapState({
      idUsuario: (state) => state.sesion.resultadoAutenticacion.IdUsuario,
    }),
    ...mapState({
      filtrosCuentaCorriente: (state) =>
        state.cuentaCorriente.filtrosCuentaCorriente,
    }),
    showTable() {
      return (
        this.filtros.cuentaCorriente != null &&
        this.filtros.agrupamiento != null
      );
    },
    cuentaCorriente() {
      if (!this.cuentasCorrientes || !this.cuentasCorrientes.length) return "";
      //buscamos el nombre de la cuenta corriente por el Id
      const nombreCuentaCorriente = this.cuentasCorrientes.filter(
        (cuenta) => cuenta.Id == this.filtros.cuentaCorriente
      )[0];
      return !nombreCuentaCorriente ? "" : nombreCuentaCorriente.Descripcion;
    },
    formaDePago() {
      if (!this.cuentasCorrientes || !this.cuentasCorrientes.length) return "";
      //buscamos el nombre de la cuenta corriente por el Id
      const nombreCuentaCorriente = this.cuentasCorrientes.filter(
        (cuenta) => cuenta.Id == this.filtros.cuentaCorriente
      )[0];
      return !nombreCuentaCorriente
        ? ""
        : ` - ${nombreCuentaCorriente.FormaPago}`;
    },
  },
  watch: {
    clienteSeleccionado() {
      this.filtros.cuentaCorriente = null;
      this.filtros.agrupamiento = 1;
      this.paginador = { ...defaultPaginador };
    }
  }
};
</script>

<style scoped>
.btnExportarExcel {
  margin-top: 15px;
  font-size: 14px !important;
  width: 90%;
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}

.container {
  display: flex;
  min-height: 500px !important;
  width: 100% !important;
}

.container_col_1 .el-collapse,
.container_col_1 .el-collapse.el-collapse-icon-position-right {
  width: 100%;
}

.el-button {
  margin-top: -1rem;
}

.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}
.seleccionador {
  width: 100%;
  padding: 0;
}
.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
@media (max-width: 900px) {
  .busqueda {
    font-size: 10px;
  }
}
@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width: 100% !important;
  }
  .container_col_2 {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-top: 20px;
  }
  .busqueda {
    font-size: 14px;
  }
}
.caption {
  color: rgba(0, 0, 0, 0.644);
  font-size: 12px;
  text-align: left;
  margin-top: 5px;
}

.pendientes-table-row {
  width: 100%;
}

.pendientes-table {
  width: 100%;
}
</style>
<style>
.realizar-consulta-btn.el-button {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
</style>